<template>
  <v-content class="pa-12">
    <v-layout justify-space-around>
      <v-flex
        d-flex
        justify-start
        align-center
        style="color: #3E7662;font-weight: bold;font-size: 24px;"
      >
        <span>จัดการรอบประชุม</span>
      </v-flex>
    </v-layout>
    <!-- Table -->
    <v-layout mt-8>
      <v-flex>
        <form-table
          :headers="headers"
          :items="meetingList"
          onChangeStatus
          :changeStatusMeeting="changeStatusMeeting"
        ></form-table>
      </v-flex>
    </v-layout>

    <!--Meeting Status Modal-->
    <template>
      <v-row justify="center">
        <v-dialog v-model="meetingDialog" persistent max-width="600px">
          <v-card class="pb-3 pt-8">
            <v-card-text>
              <!-- row 1 -->
              <v-layout px-6 mb-6>
                <v-flex style="font-size: 24px; font-weight: bold">
                  <span>จัดการรอบการประชุม</span>
                </v-flex>
              </v-layout>
              <v-layout px-6>
                <v-flex xs3 mr-3 justify-end align-center d-flex>
                  <span style="font-weight: bold;color: '#000'"
                    >ชื่องานวิจัย
                  </span>
                </v-flex>
                <v-flex justify-start align-center d-flex>
                  <v-text-field
                    v-model="meetingForm.meetingName"
                    readonly
                    dense
                    outlined
                    hide-details
                  />
                </v-flex>
              </v-layout>
              <!-- row 2 -->
              <v-layout mt-6 px-6>
                <v-flex xs3 mr-3 justify-end align-center d-flex>
                  <span style="font-weight: bold;">รอบ/วันที่การประชุม</span>
                </v-flex>
                <v-flex justify-start align-center d-flex>
                  <v-text-field
                    v-model="meetingForm.meetingDate"
                    readonly
                    outlined
                    dense
                    hide-details
                  />
                </v-flex>
              </v-layout>
              <!-- row 3 -->
              <v-layout mt-6 px-6>
                <v-flex xs3 mr-3 justify-end align-center d-flex>
                  <span style="font-weight: bold;">เวลา</span>
                </v-flex>
                <v-flex justify-start align-center d-flex>
                  <v-text-field
                    v-model="meetingForm.meetingTime"
                    readonly
                    outlined
                    dense
                    hide-details
                  />
                </v-flex>
              </v-layout>
              <!-- row 4 -->
              <v-layout mt-6 px-6>
                <v-flex xs3 mr-3 justify-end align-center d-flex>
                  <span style="font-weight: bold;">สถานที่</span>
                </v-flex>
                <v-flex justify-start align-center d-flex>
                  <v-text-field
                    v-model="meetingForm.meetingPlace"
                    readonly
                    outlined
                    dense
                    hide-details
                  />
                </v-flex>
              </v-layout>
              <!-- row 5 -->
              <v-layout mt-6 px-6>
                <v-flex xs3 mr-3 justify-end align-center d-flex>
                  <span style="font-weight: bold;">สถานะ</span>
                </v-flex>
                <v-flex shrink mr-3 justify-end align-center d-flex>
                  <v-radio-group hide-details v-model="meetingForm.isJoin" row>
                    <v-radio
                      color="#3E7662"
                      label="เข้าร่วม"
                      value="1"
                    ></v-radio>
                    <v-radio
                      color="#3E7662"
                      label="ไม่เข้าร่วม"
                      value="0"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="font-weight: bold"
                color="#3E7662"
                text
                @click="meetingDialog = false"
                >ยกเลิก</v-btn
              >
              <v-btn
                style="font-weight: bold"
                color="#3E7662"
                text
                @click="updateStatusMeeting"
                >บันทึก</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <!-- Pagination -->
    <v-layout mt-12>
      <v-flex>
        <v-pagination
          color="#3E7662"
          :length="paginateMeeting.last_page"
          :total-visible="9"
          @input="getMeetingList"
          v-model="paginateMeeting.current_page"
        ></v-pagination>
      </v-flex>
    </v-layout>

    <loading
      color="#527281"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </v-content>
</template>

<script>
import FormTable from "../../../components/table/FormTable";
import vSelect from "vue-select";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-select/dist/vue-select.css";
import { mapState, mapActions } from "vuex";
export default {
  name: "Meeting",
  components: {
    FormTable,
    vSelect,
    Loading,
  },
  computed: {
    years() {
      this.year = new Date().getFullYear();
      return Array.from(
        { length: this.year - 1900 },
        (value, index) => 1901 + 543 + index
      ).reverse();
    },
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  data: () => ({
    meetingDialog: false,
    isLoading: false,
    fullPage: true,
    paginateMeeting: {
      current_page: 1,
      from: 1,
      last_page: 1,
      per_page: 1,
      total: 1,
      to: 1,
    },
    year: "",
    year_search: "",
    headers: [
      { text: "ลำดับ", value: "number", align: "center" },
      { text: "ชื่อการประชุม", value: "meetingName", align: "center" },
      { text: "รอบ/วันที่การประชุม", value: "meetingDate", align: "center" },
      { text: "เวลา", value: "time", align: "center" },
      { text: "สถานที่", value: "location", align: "center" },
      { text: "การเข้าประชุม", value: "editMeeting", align: "center" },
    ],
    meetingList: [],
    meetingForm: {
      meetingID: "",
      meetingName: "",
      meetingDate: "",
      meetingTime: "",
      meetingPlace: "",
      isJoin: "",
    },
  }),
  created() {
    // Check Permission Access
    if (this.user.currentRole !== 3) {
      this.$router.go(-1);
    }
    this.getMeetingList();
  },
  methods: {
    getMeetingList(page) {
      this.isLoading = true;
      this.meetingList = [];
      this.$store
        .dispatch("Meeting/getMeetingList", page)
        .then((res) => {
          let i = 1;
          res.data.forEach((data) => {
            this.meetingList.push({
              number: i,
              meetingName: data.meetingName,
              meetingDate:
                "รอบที่ " + data.meetingNumber + " / " + data.meetingDate,
              time: data.meetingTime + " น.",
              id: data.id,
              status: "1",
              remainingDay: data.remainingDay,
              location: data.meetingPlace,
            });
            i++;
          });
          this.paginateMeeting.current_page = res.current_page;
          this.paginateMeeting.from = res.from;
          this.paginateMeeting.last_page = res.last_page;
          this.paginateMeeting.per_page = res.per_page;
          this.paginateMeeting.total = res.total;
          this.paginateMeeting.to = res.to;
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    changeStatusMeeting(data) {
      this.meetingDialog = true;
      this.isLoading = true;
      this.$store
        .dispatch("Meeting/getJoinMeeting", data.id)
        .then((res) => {
          this.meetingForm.meetingID = data.id;
          this.meetingForm.meetingName = data.meetingName;
          this.meetingForm.meetingDate = data.meetingDate;
          this.meetingForm.meetingPlace = data.location;
          this.meetingForm.meetingTime = data.time;
          this.meetingForm.isJoin = res.isJoin.toString();
        })
        .then(() => {
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    updateStatusMeeting() {
      this.$store
        .dispatch("Meeting/updateStatusMeeting", this.meetingForm)
        .then((res) => {
          Swal.fire({
            title: "บันทึกเรียบร้อยแล้ว",
            icon: "success",
            position: "center",
            showConfirmButton: false,
            background: "#FAF5F2",
          });
          this.meetingDialog = false;
          window.location.reload();
        })
        .catch((e) => {
          Swal.fire({
            title: "เกิดข้อผิดพลาด",
            text: "บันทึกไม่สำเร็จ",
            icon: "warning",
          });
        });
    },
  },
};
</script>

<style lang="scss">
// V-select
.style-chooser .vs__search::placeholder,
    .style-chooser .vs__dropdown-toggle,
    .style-chooser .vs__selected
        /*.style-chooser .vs__dropdown-menu:hover*/
 {
  background: #3e7662;
  border: solid 2px #3e7662;
  color: #fff;
  /*text-transform: lowercase;*/
  /*font-variant: small-caps;*/
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #fff;
}
</style>
